module.exports = __webpack_public_path__ + "static/img/pic_dkjj_title_zqgj.667cce2c.png";